import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import cx from 'classnames';
import {setUser} from 'actions/user';
import styles from './styles.module.sass';

const mapStateToProps = (state) => ({
  user: state.user
});

@connect(mapStateToProps)
class UserChange extends PureComponent {
  render() {
    const {user: {id: userId = '10'}, dispatch, className: cn} = this.props;

    return (
      <div className={cx('Header', styles.component, cn)}>
        <Select
          className={styles.userSelect}
          value={userId}
          displayEmpty
          onChange={e => dispatch(setUser({id: e.target.value}))}
        >
          <MenuItem value='10'><em>Администратор Системы</em></MenuItem>
          <MenuItem value={'30'}>Радмила Керамова</MenuItem>
          <MenuItem value={'40'}>Виктор Вахтин</MenuItem>
          <MenuItem value={'50'}>Вадим Дизенко</MenuItem>
          <MenuItem value={'60'}>Ксен Рамалданов</MenuItem>
          <MenuItem value={'52'}>Вадим Высоканов</MenuItem>
          <MenuItem value={'54'}>Александр Полойников</MenuItem>
          <MenuItem value={'56'}>Тимур Баиров</MenuItem>
        </Select>
      </div>
    );
  }
}

export default UserChange;



// WEBPACK FOOTER //
// ./src/components/common/UserChange/UserChange.jsx